import React from 'react';

function IssuesList({ configIssues, revenueLeakage }) {
  const allIssues = [];

  // Config issues
  if (configIssues) {
    for (const issue of configIssues) {
      allIssues.push({
        type: issue.type.replace(/_/g, ' '),
        recommendation: issue.recommendation,
        severity: issue.severity || 'info',
        detail: issue.adUnitCode ? `Ad Unit: ${issue.adUnitCode}` : '',
      });
    }
  }

  // Revenue leakage items
  if (revenueLeakage) {
    if (revenueLeakage.wonButNotRendered?.count > 0) {
      allIssues.push({
        type: 'WON BUT NOT RENDERED',
        recommendation: `${revenueLeakage.wonButNotRendered.count} bids won but were not rendered. Estimated loss: $${revenueLeakage.wonButNotRendered.estimatedLoss.toFixed(2)}`,
        severity: 'critical',
      });
    }
    if (revenueLeakage.filteredByFloor?.count > 0) {
      allIssues.push({
        type: 'FLOOR PRICE FILTERING',
        recommendation: `${revenueLeakage.filteredByFloor.count} bids rejected by floor price. Lost CPM: $${revenueLeakage.filteredByFloor.lostCpm.toFixed(2)}`,
        severity: 'warning',
      });
    }
    if (revenueLeakage.zeroBidAuctions?.count > 0) {
      allIssues.push({
        type: 'ZERO BID AUCTIONS',
        recommendation: `${revenueLeakage.zeroBidAuctions.count} auctions received zero bids. Check ad unit configuration and bidder setup.`,
        severity: 'warning',
      });
    }
    if (revenueLeakage.lostToGam?.count > 0) {
      allIssues.push({
        type: 'LOST TO GAM',
        recommendation: `${revenueLeakage.lostToGam.count} Prebid wins were overridden by GAM line items. Estimated loss: $${revenueLeakage.lostToGam.estimatedLoss.toFixed(2)}`,
        severity: 'warning',
      });
    }
  }

  if (allIssues.length === 0) {
    return (
      <div className="issues-list">
        <h3>Issues & Recommendations</h3>
        <p style={{ color: '#b2bec3' }}>No issues detected. Looking good!</p>
      </div>
    );
  }

  return (
    <div className="issues-list">
      <h3>Issues & Recommendations ({allIssues.length})</h3>
      {allIssues
        .sort((a, b) => {
          const order = { critical: 0, warning: 1, info: 2 };
          return (order[a.severity] || 2) - (order[b.severity] || 2);
        })
        .map((issue, i) => (
          <div key={i} className="issue-item">
            <div className="issue-header">
              <span className={`badge badge-${issue.severity}`}>{issue.severity}</span>
              <span className="issue-type">{issue.type}</span>
            </div>
            <div className="recommendation">{issue.recommendation}</div>
            {issue.detail && <div className="recommendation" style={{ marginTop: 4 }}>{issue.detail}</div>}
          </div>
        ))}
    </div>
  );
}

export default IssuesList;
